import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

import { BackIcon } from '../../../../assets/images/bk-wallet/icons';

const WalletHeader = ({
  title,
  subtitle,
  showBackButton = true,
  onBack,
  rightContent = null,
  className = ''
}) => {
  return (
    <header className={`wallet-header ${className}`}>
      <div className="wallet-header__left">
        {showBackButton && (
          <button
            type="button"
            className="wallet-header__back-btn"
            onClick={onBack}
          >
            <BackIcon />
          </button>
        )}

        <div className="wallet-header__content">
          <h1 className="wallet-header__title">{title}</h1>

          {subtitle && <p className="wallet-header__subtitle">{subtitle}</p>}
        </div>
      </div>

      {rightContent && (
        <div className="wallet-header__right">{rightContent}</div>
      )}
    </header>
  );
};

WalletHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  showBackButton: PropTypes.bool,
  onBack: PropTypes.func,
  rightContent: PropTypes.node,
  className: PropTypes.string
};

export default WalletHeader;
